var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_133096)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4996 38.6521C27.9346 38.6521 27.3927 38.8766 26.9931 39.2761C26.5936 39.6756 26.3691 40.2175 26.3691 40.7825C26.3691 41.3476 26.5936 41.8895 26.9931 42.289C27.3927 42.6885 27.9346 42.913 28.4996 42.913C29.0646 42.913 29.6065 42.6885 30.006 42.289C30.4056 41.8895 30.63 41.3476 30.63 40.7825C30.63 40.2175 30.4056 39.6756 30.006 39.2761C29.6065 38.8766 29.0646 38.6521 28.4996 38.6521Z",
    fill: "#0B132B",
    stroke: "#0B132B",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9998 27.9999C52.9998 41.5315 42.0312 52.5001 28.4997 52.5001C14.9681 52.5001 3.99951 41.5315 3.99951 27.9999C3.99951 14.4684 14.9681 3.49976 28.4997 3.49976C42.0312 3.49976 52.9998 14.4684 52.9998 27.9999Z",
    stroke: "#0B132B",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1084 22.6738C22.1084 21.4097 22.4832 20.174 23.1855 19.123C23.8878 18.0719 24.886 17.2527 26.0539 16.769C27.2217 16.2852 28.5068 16.1587 29.7466 16.4053C30.9864 16.6519 32.1253 17.2606 33.0191 18.1545C33.913 19.0483 34.5217 20.1871 34.7683 21.4269C35.0149 22.6667 34.8883 23.9518 34.4046 25.1197C33.9208 26.2875 33.1016 27.2857 32.0506 27.988C30.9995 28.6903 29.7638 29.0652 28.4997 29.0652V35.4565",
    stroke: "#0B132B",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_133096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc1);
export default __webpack_public_path__ + "static/media/doc1.caf1f936a51845aaa89692e707e2f90b.svg";
export { ForwardRef as ReactComponent };